import { Area, BannerType, Languages } from '@/constants'
import { useLocalStorage } from '@/hooks'
import { useCookie } from '@/hooks/useCookie'
import { useCookie1Y } from '@/hooks/useCookie1Y'
import type {
  BannerList,
  Keywords,
  Menu,
  ProductCompare,
  ProductViewed,
  Province,
  Region,
  SystemConfig,
} from '@/types'
import { api } from '@/utils'
import { getSaleRegion } from '@/utils/endpoint'
import constate from 'constate'
import { getCookie, setCookie } from 'cookies-next'
import { useCallback, useEffect, useMemo, useState } from 'react'
import useLocalStorageState from 'use-local-storage-state'
type Props = {
  stores: Province[] | null
  regions: Region[]
  area: string | null
  language: Languages
  systemConfig: SystemConfig
  menus: Menu[] | null

  categoryMenu: Menu[] | null
  quickMenu: Menu[] | null
  bottomMenu: Menu[] | null
  banner: BannerList[] | null
  keywords: Keywords[] | null
}

const StoreContainer = (props: Props) => {
  const [isOpenPopupLocation, setIsOpenPopupLocation] = useState(false)
  const [isDisplayAreaPopup, setIsDisplayAreaPopup] = useLocalStorage<boolean>(
    'areaPopup',
    true
  )
  const currentRegion = getCookie('Area-Code')
  const defaultSaleRegion = process.env.NEXT_PUBLIC_SALE_REGION_DEFAULT
  const [productCompares, setProductCompares] = useLocalStorageState<
    ProductCompare[]
  >('productCompare', { defaultValue: [{}, {}, {}] })

  const [productViewed, setProductViewed] = useLocalStorage<ProductViewed[]>(
    'productViewed',
    []
  )
  const [isOpenComparePopup, setIsOpenComparePopup] = useState(false)
  const [isOpenAddComparePopup, setIsOpenAddComparePopup] = useState(false)
  const [isOpenComingSoon, setIsOpenComingSoon] = useState(false)
  const [catViewId, setCatViewId] = useState<string | null>(null)
  const [stores, setStores] = useState<Province[]>([])
  const [regions, setRegions] = useState<Region[]>([])
  const [megaMenu, setMegaMenu] = useState<Menu[]>(props.menus || [])
  const [categoryMenu, setCategoryMenu] = useState<Menu[]>(
    props.categoryMenu || []
  )
  const [quickMenu, setQuickMenu] = useState<Menu[]>(props.quickMenu || [])
  const [bottomMenu] = useState<Menu[]>(props.bottomMenu || [])
  const [banner, setBanner] = useState<BannerList[]>(props.banner || [])
  const [province, setProvince] = useCookie<string | null>('province', null)
  const [destinationCode, setDestinationCode] = useCookie<string | null>(
    'destinationCode',
    null
  )
  const [isPreOrder, setIsPreOrder] = useCookie<string | null>(
    'isPreOrder',
    null
  )
  const [keywords, setKeywords] = useState<Keywords[]>(props.keywords || [])
  const [provinces, setProvinces] = useState<Province[]>([])
  const [provinceAvailable, setProvinceAvailable] = useState<Province[]>([])
  const [provinceCode, setProvinceCode] = useState<string | undefined>('')
  const [districts, setDistricts] = useState<Province[]>([])
  const [districtCode, setDistrictCode] = useState<string | undefined>('')
  const [wardCode, setWardCode] = useState<string | undefined>('')
  const [wardDistricts, setWardDistricts] = useState<Province[]>([])
  const [wards, setWards] = useState<Province[]>([])
  const [areasError, setAreasError] = useState('')
  const [areasLoading, setAreasLoading] = useState(true)
  const [areaType, setAreaType] = useState<'old' | 'new'>('old')
  const [provinceOfRegion, setProvinceOfRegion] = useState<Region[] | null>(
    null
  )
  const [regionChange, setRegionChange] = useState<string>('')
  const [selectedLang, setSelectedLang] = useCookie<
    Languages | undefined | null
  >('language', props.language || Languages.VN)
  const [area, setArea] = useCookie1Y<string | null>('area', null)
  const [areaId, setAreaId] = useCookie1Y<string | null>('area-id', null)

  const [saleRegion, setSaleRegion] = useCookie1Y<string | null>(
    'Area-Code',
    null
  )

  const [isChangeRegionModal, setIsChangeRegionModal] = useState(false)
  // Khởi tạo giá trị mặc định khi truy cập lần đầu
  useEffect(() => {
    const DEFAULT_PROVINCE = process.env.NEXT_PUBLIC_PROVINCE_DEFAULT || '01'

    if (!localStorage.getItem('area-type')) {
      localStorage.setItem('area-type', 'old')
    }
    if (!getCookie('area-type')) {
      setCookie('area-type', 'old', { maxAge: 2147483647 })
    }
    if (!localStorage.getItem('province')) {
      localStorage.setItem('province', DEFAULT_PROVINCE)
    }
    if (!getCookie('province')) {
      setCookie('province', DEFAULT_PROVINCE, { maxAge: 2147483647 })
    }
  }, [])

  useEffect(() => {
    const checkShowArea = localStorage.getItem('area-popup-seen')
    const checkHeaderRegion = getCookie('Area-Code')

    if (checkShowArea !== 'true' && !checkHeaderRegion) {
      setIsOpenPopupLocation(true)
    }
  }, [])
  useEffect(() => {
    if (regions && regions.length > 0) {
      // Chỉ khởi tạo nếu chưa có Area-Code trong cookie
      // Không override khi user đã chọn địa chỉ cụ thể
      const existingAreaCode = getCookie('Area-Code')
      if (!existingAreaCode) {
        const matchedRegion = regions.find(e => e.code === currentRegion)
        const fallbackCode =
          defaultSaleRegion && regions.find(e => e.code === defaultSaleRegion)
            ? defaultSaleRegion
            : regions[0]?.code
        setSaleRegion(matchedRegion?.code || fallbackCode || 'MB1')
      }
    }
  }, [regions])

  useEffect(() => {
    if (props.categoryMenu) {
      setCategoryMenu(props.categoryMenu)
    }
  }, [props.categoryMenu])
  useEffect(() => {
    if (props.menus) {
      setMegaMenu(props.menus)
    }
    if (props.quickMenu) {
      setQuickMenu(props.quickMenu)
    }
    if (props.keywords) {
      setKeywords(props.keywords)
    }
    if (props.banner) {
      setBanner(props.banner)
    }
  }, [props.menus, props.quickMenu, props.keywords, props.banner])

  useEffect(() => {
    let isMounted = true
    const fetchRegions = async () => {
      const res = await getSaleRegion()
      if (!isMounted) return
      if (res) setRegions(res || [])
    }

    fetchRegions()
    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (props.language && !selectedLang) {
      setSelectedLang(props.language)
    }
  }, [props.language])

  const topBanner = useMemo(() => {
    const topBanner = banner.find(e => e.type === BannerType.TOP_BAR)
    return topBanner
  }, [banner])

  const sideBarDataBanner = useMemo(() => {
    const sideBarDataBanner = banner.find(e => e.type === BannerType.SIDEBAR)
    return sideBarDataBanner ? sideBarDataBanner.items : []
  }, [banner])

  useEffect(() => {
    let isMounted = true
    const currentAreaType = getCookie('area-type') || 'old'
    setAreasLoading(true)
    api(`api/sale-region/province?areaType=${currentAreaType}`, {
      baseURL: process.env.NEXT_PUBLIC_ECOMMERCE_API_URL,
      method: 'get',
    })
      .then(async result => {
        if (!isMounted) return
        if (result instanceof Error) {
          setAreasError(result.message)
          return
        }
        setProvinceOfRegion(result.data)
      })
      .finally(() => {
        if (isMounted) setAreasLoading(false)
      })
    return () => {
      isMounted = false
    }
  }, [])

  const shallowEqualArrayBy = <T, K extends keyof T>(
    a: T[],
    b: T[],
    keys: K[]
  ) => {
    if (a === b) return true
    if (a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
      for (const k of keys) {
        if (a[i][k] !== b[i][k]) return false
      }
    }
    return true
  }

  const getProvinces = useCallback(async (type?: 'old' | 'new') => {
    const currentType = type || areaType || 'old'
    const res = await api(
      `api/area?level=${Area.PROVINCE}&areaType=${currentType}`,
      {
        method: 'get',
        baseURL: process.env.NEXT_PUBLIC_IAM_API_URL,
      }
    )
    if (res && !(res instanceof Error)) {
      const data = res.data.map((e: Province) => ({
        ...e,
        ...{ name: e.name.replace('Tỉnh ', '').replace('Thành phố ', '') },
      }))

      setProvinces(prev =>
        shallowEqualArrayBy(prev, data, ['code', 'name'] as Array<
          keyof Province
        >)
          ? prev
          : data
      )
    }
  }, [])

  const getDistricts = useCallback(
    async (provinceCode?: string) => {
      if (areaType === 'new' || !provinceCode) return
      setProvinceCode(prev => (prev === provinceCode ? prev : provinceCode))
      const res = await api(
        `api/area?level=${Area.DISTRICT}&parentCode=${provinceCode}&areaType=${
          areaType ? areaType : 'old'
        }`,
        {
          method: 'get',
          baseURL: process.env.NEXT_PUBLIC_IAM_API_URL,
        }
      )
      if (res && !(res instanceof Error)) {
        const next = res.data as Province[]
        setDistricts(prev =>
          shallowEqualArrayBy(prev, next, ['code', 'name'] as Array<
            keyof Province
          >)
            ? prev
            : next
        )
      }
    },
    [areaType, provinceCode]
  )

  const getWards = useCallback(
    async (code?: string, type?: 'old' | 'new') => {
      if (!code) return
      const currentType = type || areaType || 'old'
      if (currentType === 'old') {
        setDistrictCode(prev => (prev === code ? prev : code))
      } else {
        setProvinceCode(prev => (prev === code ? prev : code))
      }
      const res = await api(
        `api/area?level=${Area.WARD}&parentCode=${code}${
          currentType === 'old' ? '' : `&areaType=${currentType}`
        }`,
        {
          method: 'get',
          baseURL: process.env.NEXT_PUBLIC_IAM_API_URL,
        }
      )
      if (res && !(res instanceof Error)) {
        const next = res.data as Province[]
        setWards(prev =>
          shallowEqualArrayBy(prev, next, ['code', 'name'] as Array<
            keyof Province
          >)
            ? prev
            : next
        )
      }
    },
    [areaType]
  )
  useEffect(() => {
    if (areaType) {
      getProvinces(areaType)
    }
  }, [areaType])
  useEffect(() => {
    if (areaType === 'old' && provinces.length > 0 && provinceCode) {
      getDistricts(provinceCode)
      getWards(districtCode)
    }
    if (areaType === 'new' && provinces.length > 0 && provinceCode) {
      getWards(provinceCode)
    }
  }, [
    areaType,
    provinces.length,
    provinceCode,
    districtCode,
    getDistricts,
    getWards,
  ])

  return {
    areaType,
    setAreaType,
    province,
    setProvince,
    area,
    setArea,
    areaId,
    setAreaId,
    setSelectedLang,
    setDestinationCode,
    destinationCode,
    selectedLang,
    stores,
    banner,
    megaMenu,
    quickMenu,
    categoryMenu,
    topBanner,
    sideBarDataBanner,
    keywords,
    setStores,
    isOpenPopupLocation,
    setIsOpenPopupLocation,
    isDisplayAreaPopup,
    bottomMenu,
    setIsDisplayAreaPopup,
    isOpenComingSoon,
    setIsOpenComingSoon,
    productCompares,
    setProductCompares,
    isOpenComparePopup,
    setIsOpenComparePopup,
    isOpenAddComparePopup,
    setIsOpenAddComparePopup,

    productViewed,
    setProductViewed,
    catViewId,
    setCatViewId,
    isPreOrder,
    setIsPreOrder,
    saleRegion,
    setSaleRegion,
    regions,
    setRegions,
    currentRegion,
    provinces,
    setProvinces,
    districts,
    setDistricts,
    wards,
    getDistricts,
    getProvinces,
    provinceCode,
    setWardDistricts,
    wardDistricts,
    getWards,
    setWards,
    setProvinceCode,
    areasError,
    areasLoading,
    districtCode,
    setWardCode,
    wardCode,
    setDistrictCode,
    provinceOfRegion,
    setProvinceOfRegion,
    provinceAvailable,
    setProvinceAvailable,
    isChangeRegionModal,
    setIsChangeRegionModal,
    regionChange,
    setRegionChange,
  }
}

export const [StoreProvider, useStore] = constate(StoreContainer)
